import store from '@/store/store'
import i18n from '../i18n/i18n'
import ElementEnum from "@/app/shared/ElementEnum.js";

export default {
  install(Vue) {
    Vue.prototype.$systemUnits = {
      getDensityLabel: () => {
        return i18n.t('GradeControl.Density') + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.DensityUnitImperial' : 'GradeControl.DensityUnitMetric');
      },
      getCappingLabel: (label) => {
        return i18n.t('GradeControl.Location.Capping') + ' ' + i18n.t(label) + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit');
      },
      getCappingLabelNoPrefix: (label) => {
        return i18n.t(label) + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit');
      },
      getVolumeLabel: () => {
        return i18n.t('GradeControl.Volume') + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.VolumeUnitImperial' : 'GradeControl.VolumeUnitMetric');
      },
      convertDensityRounded: (value) => {
        if (typeof value === 'string') {
          value = parseFloat(value);
        }

        return value === null ? null : store.getters.isProjectImperial ? ((value * 0.0283168) / (2000 / 2204.62)).toFixed(2) : value.toFixed(2);
      },
      convertDensity: (value) => {
        return store.getters.isProjectImperial ? (value * 0.0283168) / (2000 / 2204.62) : value;
      },
      convertDensityToMetric: (value) => {
        return store.getters.isProjectImperial ? (value / 0.0283168) * (2000 / 2204.62) : value;
      },
      getGradeLabel: (label) => {
        return i18n.t(label) + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit');
      },
      getGradeUnitLabel: () => {
        return i18n.t(store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit');
      },
      convertGradeRounded: (value, element) => {
        if (typeof value === 'string') {
          value = parseFloat(value);
        }

        if (element === undefined || (element === ElementEnum.Gold || element === ElementEnum.Silver)) {
          return value === null || isNaN(parseFloat(value)) ? value : store.getters.isProjectImperial ? (parseFloat(value) / 34.2857).toFixed(2) : parseFloat(value).toFixed(2);
        }
        return value === null || isNaN(parseFloat(value)) ? value : parseFloat(value).toFixed(3);
      },
      convertGrade: (value, element) => {
        if (element === undefined || (element === ElementEnum.Gold || element === ElementEnum.Silver)) {
          return store.getters.isProjectImperial ? (value / 34.2857) : value;
        }
        return value;
      },
      convertGradeToMetric: (value, element) => {
        if (element === undefined || (element === ElementEnum.Gold || element === ElementEnum.Silver)) {
          return store.getters.isProjectImperial ? value * 34.2857 : value;
        }
        return value;
      },
      convertVolumeRounded: (value) => {
        if (typeof value === 'string') {
          value = parseFloat(value);
        }
        
        return value === null || value === undefined || isNaN(parseInt(value)) ? value : (store.getters.isProjectImperial ? value * 3.28084 : value).toFixed(1);
      },
      convertVolume: (value) => {
        return store.getters.isProjectImperial ? value * 3.28084 : value;
      },
      convertVolumeToMetric: (value) => {
        return store.getters.isProjectImperial ? value / 3.28084 : value;
      },
      getTonnageLabel: () => {
        return i18n.t('GradeControl.Tonnage') + ' ' + i18n.t(store.getters.isProjectImperial ? 'GradeControl.TonnageUnitImperial' : 'GradeControl.TonnageUnitMetric');
      },
      convertTonnage: (value) => {
        return store.getters.isProjectImperial ? value * 1.1023 : value;
      },
      convertTonnageToMetric: (value) => {
        return store.getters.isProjectImperial ? value / 1.1023 : value;
      }
    }
  }
}
